/**
 * Created by Damian on 2017-11-17.
 */

import { observable } from 'mobx'

class MediaList{

  @observable elements = []

  constructor(){

  }

  set(list){
    this.elements = list;
  }
}

let mediaList = new MediaList();
export default mediaList;